import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
export function ProblemSection() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  return <div ref={ref} className="w-full px-6 py-32 bg-gradient-to-b from-transparent via-slate-900/40 to-slate-900/30 relative" data-id="element-154">
      {/* Chapter indicator */}
      <motion.div initial={{
      opacity: 0,
      x: -50
    }} animate={inView ? {
      opacity: 1,
      x: 0
    } : {}} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto mb-12" data-id="element-155">
        <div className="flex items-center gap-6 mb-8" data-id="element-156">
          <div className="text-8xl font-bold text-purple-500/20" style={{
          fontFamily: 'Oswald, sans-serif'
        }} data-id="element-157">
            01
          </div>
          <div data-id="element-158">
            <p className="text-sm text-cyan-400 font-semibold tracking-wider uppercase mb-2" data-id="element-159">
              Chapter One
            </p>
            <h2 className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-purple-400 to-cyan-400 bg-clip-text text-transparent" style={{
            fontFamily: 'Oswald, sans-serif',
            textShadow: '0 0 40px rgba(139, 92, 246, 0.3)'
          }} data-id="element-160">
              The Call to Adventure
            </h2>
          </div>
        </div>
      </motion.div>
      <div className="max-w-4xl mx-auto space-y-12" data-id="element-161">
        <motion.h3 initial={{
        opacity: 0,
        y: 30
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 0.3,
        duration: 0.8
      }} className="text-3xl md:text-4xl font-bold text-center text-white" style={{
        fontFamily: 'Oswald, sans-serif'
      }} data-id="element-162">
          Does this sound familiar?
        </motion.h3>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 0.5,
        duration: 0.8
      }} className="space-y-8 text-lg text-gray-300 leading-relaxed font-light" data-id="element-163">
          <p data-id="element-164">
            You've been doing all the "right" things. You've tried the diets,
            taken the supplements, and seen the specialists. You've read the
            articles, listened to the podcasts, and tried the protocols. You're
            constantly researching and you're constantly trying new things.
          </p>
          <p data-id="element-165">
            You feel stuck in a cycle of busywork, stuck chasing symptoms that
            leave you exhausted and you're barely closer to the results you
            want. Your problem certainly isn't a lack of effort. But you know
            that DESPITE your effort, you're still not doing the right things.
          </p>
          <p className="text-xl font-medium text-cyan-400 relative" data-id="element-166">
            And in a lot of ways, you don't even know what the "right" things
            are.
            <span className="absolute -bottom-2 left-0 right-0 h-px bg-gradient-to-r from-transparent via-cyan-400/50 to-transparent" data-id="element-167" />
          </p>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={inView ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        delay: 0.7,
        duration: 0.8
      }} data-id="element-168">
          <TestimonialCard text="I was at rock bottom. Doctors, meds, nothing worked... This… it gave me my life back." highlight={true} profileImage="https://uploadthingy.s3.us-west-1.amazonaws.com/v9wd2NeXYs5qjjmhF1TRpc/Screenshot_2025-11-10_201317.png" name="Nick B." data-id="element-169" />
        </motion.div>
        {/* Dramatic divider */}
        <motion.div initial={{
        scaleX: 0
      }} animate={inView ? {
        scaleX: 1
      } : {}} transition={{
        delay: 0.9,
        duration: 1
      }} className="relative py-12" data-id="element-170">
          <div className="h-px w-full bg-gradient-to-r from-transparent via-purple-500/50 to-transparent" data-id="element-171" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-4 h-4 rounded-full bg-gradient-to-r from-purple-500 to-cyan-500 shadow-lg shadow-purple-500/50" data-id="element-172" />
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 1.1,
        duration: 0.8
      }} className="pt-8" data-id="element-173">
          <h3 className="text-4xl md:text-5xl font-bold text-center bg-gradient-to-r from-red-400 via-purple-400 to-cyan-400 bg-clip-text text-transparent mb-12" style={{
          fontFamily: 'Oswald, sans-serif',
          textShadow: '0 0 60px rgba(239, 68, 68, 0.3)'
        }} data-id="element-174">
            Avoid Falling for the Same Trap Keeping Most People Stuck
          </h3>
          <div className="space-y-8 text-lg text-gray-300 leading-relaxed font-light" data-id="element-175">
            <p data-id="element-176">
              People think the key is finding the next tactic, the next
              supplement, the next diet, the next "biohack." But this endless
              chase of surface-level tactics is the very thing keeping you
              stuck.
            </p>
            <p data-id="element-177">
              Content creators are incentivized to constantly talk about the
              NEXT thing and generate hype to hook people. But these are all
              surface-level approaches when you have to fix a deeper issue
              within your body.
            </p>
            <p className="text-xl font-medium text-white" data-id="element-178">
              When you take a supplement for joint pain, another for brain fog,
              follow different advice from a heart specialist, and try a new
              diet for energy…
            </p>
            <p className="text-lg text-gray-300 font-light" data-id="element-179">
              You might feel like you're doing all the right things.
            </p>
            <div className="relative py-8" data-id="element-180">
              <p className="text-3xl md:text-4xl font-bold text-center text-red-400 relative" style={{
              fontFamily: 'Oswald, sans-serif',
              textShadow: '0 0 30px rgba(248, 113, 113, 0.5)'
            }} data-id="element-181">
                But you will stay stuck.
                <motion.div initial={{
                scaleX: 0
              }} animate={inView ? {
                scaleX: 1
              } : {}} transition={{
                delay: 1.5,
                duration: 0.6
              }} className="absolute -bottom-2 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-red-500 to-transparent rounded-full" data-id="element-182" />
              </p>
            </div>
            <p className="text-2xl font-medium text-cyan-400 text-center" data-id="element-183">
              Because you aren't fixing the CORE problem.
            </p>
            <p className="text-lg" data-id="element-184">
              Your body is not a collection of broken parts to be worked on.
              It's a single, integrated, unified system where everything affects
              everything else.
            </p>
            <p className="text-lg" data-id="element-185">
              Chasing symptoms is just like playing endless whack-a-mole.
            </p>
            <div className="bg-gradient-to-r from-purple-900/40 to-cyan-900/40 border-2 border-cyan-500/50 rounded-xl p-8 shadow-2xl shadow-cyan-500/20" data-id="element-186">
              <p className="text-2xl font-semibold text-white text-center leading-relaxed" data-id="element-187">
                The only thing that matters is to stop chasing symptoms and
                finally fix the real problem at the source. Deep inside your
                body's cells.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
}